import React from 'react';

import { useInitializers } from 'Hooks/useInitializers';
import { useUserActivity } from 'Hooks/useUserActivity';

/**
 * Execute Global Events/Event Listeners on Aurora App, for example, execute something upon user
 * login, or as soon as we have application info.
 */
export const AuroraInitializers: React.FC = ({ children }) => {
  useInitializers();
  useUserActivity();

  return <>{children}</>;
};
